import client from './client';
import { ReportFilters, TripProfitLossRow, VehicleProfitabilityRow, DebtStatusRow } from '../types/api';

interface TripProfitLossReport {
  trips: TripProfitLossRow[];
  summary: {
    totalRevenue: number;
    totalExpenses: number;
    totalSalary: number;
    totalProfit: number;
    tripCount: number;
  };
}

interface VehicleProfitabilityReport {
  vehicles: VehicleProfitabilityRow[];
  summary: {
    totalExpenses: number;
    totalDriverWages: number;
    totalCost: number;
    totalTrips: number;
  };
}

interface DebtStatusReport {
  supplierDebts: DebtStatusRow[];
  customerDebts: DebtStatusRow[];
  summary: {
    totalSupplierDebt: number;
    totalCustomerDebt: number;
    totalDebt: number;
  };
}

export const reportAPI = {
  tripProfitLoss: async (filters: ReportFilters): Promise<TripProfitLossReport> => {
    const response = await client.get('/reports/trip-profitloss', { params: filters });
    return response.data.data;
  },

  vehicleProfitability: async (filters: ReportFilters): Promise<VehicleProfitabilityReport> => {
    const response = await client.get('/reports/vehicle-profitability', { params: filters });
    return response.data.data;
  },

  debtStatus: async (): Promise<DebtStatusReport> => {
    const response = await client.get('/reports/debt-status');
    return response.data.data;
  },

  exportExcel: async (params: {
    type: 'trip-profitloss' | 'vehicle-profitability' | 'debt-status';
    startDate?: string;
    endDate?: string;
    vehicleId?: number;
    driverId?: number;
    supplierId?: number;
    customerId?: number;
  }): Promise<Blob> => {
    const response = await client.get('/reports/export', {
      params: { ...params, format: 'xlsx' },
      responseType: 'blob',
    });
    return response.data;
  },
};
